module.exports = __webpack_public_path__ + "static/media/bottomNew.46762f79.png";